import AppConfig from "../AppConfig";
function filterValueActions(items, toExclude) {
  return items.filter((item) => !toExclude.includes(item.type));
}
export function filterCloudValueActions(valueActions, toExclude) {
  if (!AppConfig.isCloud()) {
    return valueActions;
  }
  return filterValueActions(valueActions, toExclude);
}
export default filterValueActions;
